module.exports = __webpack_public_path__ + "static/media/siddharth-nandi-hills-trip-13.a61fa094.png";